import { request } from "./http";

export interface BiOverview {
  aum_per_currency: Record<string, number>;
  customers: number;
  fills_24h: number;
  checked_at: string;
}

export interface VolumeRow {
  day: string;
  notional: number;
  orders: number;
}

export interface VenueRow {
  venue: string;
  fills: number;
  avg_latency_ms: number | null;
  avg_slippage_bps: number | null;
}

export const bi = {
  overview: () => request<BiOverview>("/api/v1/admin/bi/overview"),
  volume: (days = 30) => request<VolumeRow[]>(`/api/v1/admin/bi/volume?days=${days}`),
  venues: (days = 30) => request<VenueRow[]>(`/api/v1/admin/bi/venues?days=${days}`),
};
